module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft2.e0ed6795.jpg";